import React, { Fragment, useEffect, useState } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import Select from "react-select";
import { Country } from "country-state-city";
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { useLocation, useNavigate } from "react-router-dom";
import {
  getIndustryData,
  addPackages,
  getTaxGroup,
  getPackages,
  uploadPackages,
} from "../../../CommonURL";
import { getDataWithToken, postDataWithToken } from "../../../Utils/restUtils";
import {
  DiscriptionText,
  Name,
  NameError,
  SubmitForm,
  AddPackages,
  Features,
  Price,
  MRP,
  TaxGroup,
  Industry,
  SetupCost,
  ExpiryDate,
  Days,
  FeaturesError,
  PriceError,
  MrpError,
  TaxGroupError,
  IndustryError,
  SetupCostError,
  ExpiryDateError,
  DaysError,
  HSN,
  HSNError,
  EditPackages,
  MinConnection,
  MaxConnection,
  MaxConnectionError,
  MinConnectionError,
  PriceCalculation,
  SMSActive,
  TaxClass,
  PriceCalError,
  Currencys,
} from "../../../Constant";
import Typeahead from "../../../CommonElements/TypeAhead";
import SpinnerLoader from "../../../Layout/SpinnerLoader";
import Transparentspinner from "../../Common/loader/Transparentspinner";

const PackagesEdit = () => {
  const location = useLocation();
  const searchParams = location.search;
  const params = new URLSearchParams(searchParams);
  const param1 = params.get("id");
  const packageSchema = Yup.object().shape({
    industry: Yup.mixed().required(),
    taxGroup: Yup.mixed().required(),
    setupCost: Yup.number().required(),
    name: Yup.string().required(),
    features: Yup.string().required(),
    price: Yup.number().required(),
    mrp: Yup.number().required(),
    minCon: Yup.number().typeError("Minimum connection is required").required(),
    maxCon: Yup.number().typeError("Maximum connection is required").required(),
    priceCal: Yup.mixed().required(),
    currency: Yup.mixed().required(),
    country: Yup.mixed().required(),
    expiryDate: Yup.number().required(),
    hsn: Yup.string().required().typeError("HSN is required"),
  });
  const {
  register,
  handleSubmit,
  control,
  formState: { errors },
  setValue,
} = useForm({
  resolver: yupResolver(packageSchema),
});

  const [smsCheck, setSmsCheck] = useState(new Date());
  const [industry, setIndustry] = useState([]);
  const [tax, setTax] = useState([]);
  const [taxOption, setTaxOption] = useState([]);
  const [industryOption, setIndustryOption] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const navigate = useNavigate();
  const priceCalOptions = [
    { value: "fixed", label: "Fixed Amount" },
    { value: "per_unit", label: "Per Unit" },
  ];
  const currencyOptions = [
  { value: "INR", label: "Indian Rupee" },
  { value: "USD", label: "US Dollar" },
];
  useEffect(() => {
    industryData();
    taxData();
    getPackageData();
  }, []);

  useEffect(() => {
    setTaxOption(
      tax.map((item) => ({
        value: item.id,
        label: item.title,
      })),
    );
    setIndustryOption(
      industry.map((item) => ({
        value: item.id,
        label: item.name,
      })),
    );
  }, [tax, industry]);

  const industryData = async () => {
    const data = await getDataWithToken(getIndustryData);
    setIndustry(data.data);
  };

  const taxData = async () => {
    const getTaxdata = await getDataWithToken(getTaxGroup);
    setTax(getTaxdata.data);
  };

  const getLabelForPriceCalculation = (value) => {
    const option = priceCalOptions.find((option) => option.value === value);
    return option ? option.label : "";
  };

  const getPackageData = async () => {
    setLoading(true);
    let data = await getDataWithToken(getPackages + `?package_id=${param1}`);
    setValue("name", data.data[0].name);
    setValue("features", data.data[0].features);
    setValue("price", data.data[0].price);
    setValue("mrp", data.data[0].mrp);
    setValue("expiryDate", data.data[0].duration);
    setValue("minCon", data.data[0].min_connection);
    setValue("maxCon", data.data[0].max_connection);
    setValue("hsn", data.data[0].hsn_no);
    setValue("setupCost", data.data[0].setup_cost);
    setValue("taxGroup", {
      label: data.data[0].tax_group_name,
      value: data.data[0].tax_group_id,
    });
    setValue("industry", {
      label: data.data[0].industry_name,
      value: data.data[0].industry_type_id,
    });
    setValue("priceCal", {
      label: getLabelForPriceCalculation(data.data[0].price_calculation),
      value: data.data[0].price_calculation,
    });
    setValue("currency", {
  label: data.data[0].currency === "INR" ? "Indian Rupee" : "US Dollar",
  value: data.data[0].currency,
});

const countryObj = {
  name: data.data[0].country,
  isoCode: data.data[0].iso_code,
};

setSelectedCountry(countryObj);

setValue("country", countryObj);
setValue("country_name", data.data[0].country);
setValue("country_iso", data.data[0].iso_code);
    const isSmsOn = data.data[0].sms === "on";
    setSmsCheck(isSmsOn);
    setValue("sms", isSmsOn);
    setLoading(false);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    const postRequest = {
      package_id: param1,
      name: data.name,
      price: data.price,
      mrp: data.mrp,
      tax_group_id: data.taxGroup.value,
      industry_type_id: data.industry.value,
      features: data.features,
      setup_cost: data.setupCost,
      duration: data.expiryDate,
      min_connection: data.minCon,
      hsn_no: data.hsn,
      max_connection: data.maxCon,
      price_calculation: data.priceCal.value,
      sms: data.sms,
      currency: data.currency.value,   
country: data.country_name,
iso_code: data.country_iso,
    };
    const editPackageResponse = await postDataWithToken(
      uploadPackages,
      postRequest,
    );
    if (editPackageResponse.data.message === "success") {
      toast.success("Success...!");
      navigate(`${process.env.PUBLIC_URL}/configuration/packages`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    }
    setLoading(false);
  };
  return (
    <Fragment>
      {loading && <Transparentspinner />}

      <Breadcrumbs
        mainTitle="Edit Packages"
        parent="Configuration"
        title="Packages"
      />
      <Card>
        <CardHeader className="pb-0">
          <H3>{EditPackages}</H3>
          {/* <span>{CustomstyleText} <code className="text-danger">{novalidate}</code> {CustomstyleText2} <code className="text-danger">&lt;{form}&gt;</code>{CustomstyleText3}</span><span>{CustomstyleText4} <code className="text-danger">{invalid} </code> {and} <code className="text-danger">{valid} </code> {CustomstyleText5}</span> */}
        </CardHeader>
        <CardBody>
          <Form
            className="needs-validation"
            noValidate
            onSubmit={handleSubmit(onSubmit)}
          >
            <Row className="g-3">
              <Col md="6">
                <Label className="form-label">{Industry}</Label><span className="requireStar">*</span>
                <Controller
                  name="industry"
                  control={control} // Set the initial value to null
                  render={({ field }) => (
                    <Typeahead
                      options={industryOption}
                      onChange={(value) => {
                        field.onChange(value); // Update the value in react-hook-form
                      }}
                      value={field.value}
                    />
                  )}
                />
                <span className="text-danger">
                  {errors.industry && IndustryError}
                </span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="name">
                  {Name}
                </Label><span className="requireStar">*</span>
                <input
                  className="form-control"
                  id="name"
                  type="text"
                   placeholder="Name"
                  {...register("name", { required: true })}
                />
                <span className="text-danger">{errors.name && NameError}</span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="hsn">
                  {HSN}
                </Label><span className="requireStar">*</span>
                <input
                  className="form-control"
                  id="hsn"
                  type="text"
                  placeholder="HSN"
                  {...register("hsn", { required: true })}
                />
                <span className="text-danger">{errors.hsn && HSNError}</span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="mincon">
                  {MinConnection}
                </Label><span className="requireStar">*</span>
                <input
                  className="form-control"
                  id="mincon"
                  type="number"
                  placeholder="Minimum Connection"
                  min="0"
                  {...register("minCon", { required: true })}
                />
                <span className="text-danger">
                  {errors.minCon ? MinConnectionError : ""}
                </span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="maxcon">
                  {MaxConnection}
                </Label><span className="requireStar">*</span>
                <input
                  className="form-control"
                  id="maxcon"
                  type="number"
                  min="0"
                  placeholder="Maximum Connection"
                  {...register("maxCon", { required: true })}
                />
                <span className="text-danger">{errors.maxCon && MaxConnectionError}</span>
              </Col>
              <Col md="6">
                <Label className="form-label">{PriceCalculation}</Label><span className="requireStar">*</span>
                <Controller
                  name="priceCal"
                  control={control} // Set the initial value to null
                  render={({ field }) => (
                    <Typeahead
                      options={priceCalOptions}
                      onChange={(value) => {
                        field.onChange(value); // Update the value in react-hook-form
                      }}
                      value={field.value}
                    />
                  )}
                />
                <span className="text-danger">
                  {errors.priceCal ? PriceCalError : ""}
                </span>
              </Col>
              <Col md="6">
  <Label className="form-label">{Currencys}</Label>
  <span className="requireStar">*</span>

  <Controller
    name="currency"
    control={control}
    render={({ field }) => (
      <Typeahead
        options={currencyOptions}
        value={field.value}
        onChange={field.onChange}
      />
    )}
  />

  <span className="text-danger">
    {errors.currency ? "Currency is required" : ""}
  </span>
</Col>
<Col md="6">
  <Label className="form-label">Country</Label>
  <span className="requireStar">*</span>

  <Controller
    name="country"
    control={control}
    rules={{ required: "Country is required" }}
    render={({ field }) => (
      <Select
        {...field}
        options={Country.getAllCountries()}
        getOptionLabel={(opt) => opt.name}
        getOptionValue={(opt) => opt.isoCode}
        value={selectedCountry}
        onChange={(item) => {
          setSelectedCountry(item);

          field.onChange(item);

          setValue("country_name", item.name);
          setValue("country_iso", item.isoCode);
        }}
      />
    )}
  />

  <span className="text-danger">{errors.country?.message}</span>
</Col>
              <Col md="6">
                <Label className="form-label" for="price">
                  {Price}
                </Label><span className="requireStar">*</span>
                <input
                  className="form-control"
                  id="price"
                  type="text"
                  placeholder="Price"
                  {...register("price", { required: true })}
                />
                <span className="text-danger">
                  {errors.price && PriceError}
                </span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="mrp">
                  {MRP}
                </Label><span className="requireStar">*</span>
                <input
                  className="form-control"
                  id="mrp"
                  type="text"
                  placeholder="MRP"
                  {...register("mrp", { required: true })}
                />
                <span className="text-danger">{errors.mrp && MrpError}</span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="setupcost">
                  {SetupCost}
                </Label><span className="requireStar">*</span>
                <input
                  className="form-control"
                  id="setupcost"
                  type="number"
                  min="0"
                  placeholder="Setup Cost "
                  {...register("setupCost", { required: true })}
                />
                <span className="text-danger">{errors.setupCost && SetupCostError}</span>
              </Col>
              <Col md="6">
                <Label className="form-label">{TaxClass}</Label><span className="requireStar">*</span>
                <Controller
                  name="taxGroup"
                  control={control} // Set the initial value to null
                  render={({ field }) => (
                    <Typeahead
                      options={taxOption}
                      onChange={(value) => {
                        field.onChange(value); // Update the value in react-hook-form
                      }}
                      value={field.value}
                    />
                  )}
                />
                <span className="text-danger">{errors.taxGroup ? TaxGroupError : ''}</span>
              </Col>
              <Col md="6">
                <FormGroup className="mb-3">
                  <Label className="form-label" for="expdate">
                    {ExpiryDate}
                  </Label><span className="requireStar">*</span>
                  <input
                    className="form-control"
                    id="expdate"
                    type="number"
                    placeholder="Expiry Duration "
                    min="0"
                    {...register("expiryDate", { required: true })}
                  />
                  <span className="text-danger">{errors.expiryDate && ExpiryDateError}</span>
                </FormGroup>
              </Col>
            </Row>
            <Row className="g-3">
              <Col md="6">
                <div className="form-check checkbox checkbox-primary mb-0">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="sms"
                    {...register("sms")} // Ensure 'sms' is registered with react-hook-form
                    defaultChecked={smsCheck} // Ensure correct initial state
                  />
                  <label className="form-check-label" htmlFor="sms">
                    {SMSActive}
                  </label>
                </div>
              </Col>
            </Row>
            <Row className="g-3">
              <Col>
                <Label className="form-label pt-3">{Features}</Label><span className="requireStar">*</span>
                <Controller
                  name="features"
                  control={control}
                  render={({ field }) => (
                    <textarea
                      className="form-control"
                      placeholder="Features"
                      {...field}
                      rows="3" // Set the 'rows' attribute to 3 here
                    />
                  )}
                />
              </Col>
            <span className="text-danger">{errors.features && FeaturesError}</span>
            </Row>
            <FormGroup></FormGroup>
            <Btn attrBtn={{ color: "primary" }} type="submit">
              {SubmitForm}
            </Btn>
          </Form>
        </CardBody>
      </Card>
    </Fragment>
  );
};
export default PackagesEdit;
